import React from 'react';
import { observer } from 'mobx-react';
import { computed } from 'mobx';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';
import Navigation from 'components/navigation';
import { keys } from 'lodash';
import InPlaceLanguageSelect from 'components/form/in_place_language_select';
import { AppUI, ForumUI } from '@seedlang/state';
import { AiLanguages } from '@seedlang/constants';
import withRouteParams from 'utils/with_route_params';
import { Outlet } from 'react-router-dom';

const Wrapper = styled.div`
  margin-top: 20px;
  ul {
    margin-bottom: 20px;
  }
  li {
    margin-left: 20px!important;
    list-style-type: disc!important;
  }
`;

const NavigationRow = styled.div`
  display: flex;
  align-items: center;
`;

const NavigationWrapper = styled.div`
  flex: 1;
`;

const Language = styled.div`
  width: 100px;
`;

const Message = styled.div`
  background: #FFF;
  padding: 20px;
`;

const TranslatorWrapper = styled.div`
  margin-top: 20px;
`;

@observer
class Translator extends React.Component {

  @computed get supportedByAi() {
    return keys(AiLanguages).includes(AppUI.user.languageId);
  }

  constructor(props) {
    super(props);
    AppUI.languageStore.getShow({ids: {languageId: props.params.languageId}});
  }

  updateLanguage = (val) => {
    AppUI.routeStore.routeToNamed(AppUI.routeStore.routeName, {languageId: val});
    AppUI.authUserStore.update({data: {language_id: val}}, this.afterUpdateUser);
  }

  afterUpdateUser = () => {
    AppUI.loadUser(this.afterLoadUser);
  }

  afterLoadUser = (resp) => {
    AppUI.setAuthUserStoreShowData(resp);
    if (AppUI.routeStore.routeName === 'translator.forum_threads.show') {
      ForumUI.loadForum(AppUI.user.languageForumId, true);
      ForumUI.forumThreadStore.getIndex({filters: {hidden: false, forum_id: AppUI.user.languageForumId}});
    }
  }

  render() {
    return (
      <Wrapper>
        {
          this.supportedByAi &&
            <div className='builder'>
              <h3>An Important Update</h3>
              <Message>
                <p>Thank you to everyone that has helped us with our translator program, over the years our translators have created more than 100k translations for our community and helped to make the app more accessible to many people all around the world.</p>
                <p>Recent advances in AI have made it so that we feel confident that we can produce high quality translations automatically across as many as 30 languages. But we would still very much appreciate your help! Over the next weeks we will transition the translator program to where our translators can help with:</p>
                <ul>
                  <li>Reviewing translations that were flagged by our students.</li>
                  <li>Helping us with translating labels that appear within the app.</li>
                  <li>Reviewing text for our grammar descriptions.</li>
                </ul>
                <p>Our ultimate goal is that when someone uses the app, that they never have to see any English at all. We appreciate your help in making this goal a reality!</p>
                <p>If you have any questions or concerns, please email us at help@seedlang.com.</p>
                <p>Thanks again for all of your help!</p>
                <p><span role="img" aria-label="celebration">🎉🎉🎉🎉</span></p>
              </Message>
            </div>
        }

        {
          (AppUI.user.admin || !this.supportedByAi) &&
          <TranslatorWrapper>
            <NavigationRow>
              <NavigationWrapper>
                {
                  AppUI.user?.languageId &&
                  <Navigation
                    currentRoute={AppUI.routeStore.routeName}
                    links={[
                      {
                        link: 'translator.home',
                        title: 'Home',
                        params: {languageId: AppUI.user.languageId},
                      },
                      {
                        link: 'translator.decks_index',
                        title: 'Decks',
                        params: {languageId: AppUI.user.languageId},
                      },
                      {
                        link: 'translator.sentences_index',
                        title: 'Sentences',
                        params: {languageId: AppUI.user.languageId},
                      },
                      {
                        link: 'translator.words',
                        title: 'Words',
                        params: {languageId: AppUI.user.languageId},
                      },
                      {
                        link: 'translator.users',
                        title: 'Translators',
                        params: {languageId: AppUI.user.languageId},
                      },
                    ]}
                  />
                }
              </NavigationWrapper>
              <Language>
                <InPlaceLanguageSelect
                  showEdit
                  includeBlank
                  value={AppUI.user.languageId}
                  onChange={this.updateLanguage}
                />
              </Language>
            </NavigationRow>
          <Outlet />
        </TranslatorWrapper>
        }
      </Wrapper>
    );
  }
}

export default withRouteParams(ErrorBoundary(Translator));
